import { Column, Row } from '@components/LinearLayout';
import { P, PSmall, PSmallBold } from '@components/Typography';

import styled from 'styled-components';

export const AgendaItemsRoot = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;
  grid-gap: 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    display: flex;
    flex-direction: column;
    grid-gap: 1.5rem;
    padding: 2rem;
  }
`;

export const SessionItemHeadlineSection = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1rem;
`;

export const SessionItemHeadlineItemText = styled(PSmallBold)<{
  color?: string;
}>`
  color: ${({ color, theme }) => color || theme.color.white};
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight800};
  text-align: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size18};
  }
`;

export const SessionItemHeadlineItem = styled.div<{
  color?: string;
  padding?: string;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  box-sizing: border-box;
  border: 4px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
  padding: ${({ padding }) => padding || '1rem 3.5rem'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    padding: ${({ padding }) => padding || '0.5rem 2.5rem'};
  }
`;

export const SessionDescription = styled(Column)<{ $gap?: string }>`
  gap: ${({ $gap }) => $gap || '3rem'};
`;

export const SessionContentWrapper = styled.div``;

export const SessionTitleWrapper = styled.div<{ $color: string }>`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  padding-bottom: 3rem;
  border-bottom: 4px solid ${({ theme }) => theme.color.lightGrey};
  color: ${({ $color }) => $color};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding-bottom: 2rem;
  }
`;

export const SessionTitle = styled(P)`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size35};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height150};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    font-size: ${({ theme }) => theme.fontSize.size26};
    font-weight: 800;
    line-height: ${({ theme }) => theme.lineHeight.height140};
  }
`;

export const SessionTitleRemaningText = styled.div`
  color: ${({ theme }) => theme.color.mobilityGrey};
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight900};
  line-height: ${({ theme }) => theme.lineHeight.height140};
  margin-bottom: 4rem;
`;

export const SessionDescriptionText = styled(PSmall)`
  height: auto;
  padding: 4rem;
  color: ${({ theme }) => theme.color.mobilityGrey};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 1.5rem;
  }
`;

export const SessionInfoDetailsWrapper = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: row;
  gap: ${({ gap }) => gap || '1rem'};
`;

export const SessionInfoWrapper = styled.div<{ gap?: string }>`
  display: flex;
  flex-direction: row;
  gap: ${({ gap }) => gap || '1rem'};

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    flex-direction: column;
  }
`;

export const SessionInfoText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.size18};
  font-weight: ${({ theme }) => theme.fontWeight.weight400};
  line-height: ${({ theme }) => theme.lineHeight.height150};
`;

export const Tags = styled(Row)`
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1.5rem;
`;

export const Tag = styled.div<{ $color: string }>`
  background-color: ${({ $color }) => $color};
  color: ${({ theme }) => theme.color.white};
  border-radius: ${({ theme }) => theme.borderRadius.radius20};
  font-size: ${({ theme }) => theme.fontSize.size14};
  line-height: ${({ theme }) => theme.lineHeight.height150};
  padding: 0.5rem 1.5rem;
  transition: background-color 600ms cubic-bezier(0.4, 0.47, 0.13, 0.88);
`;

export const SessionItemContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  padding: 2rem 2rem 3rem 2rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    padding: 2rem 1rem;
  }
`;

export const BorderedWrapper = styled.div`
  border: 4px solid ${({ theme }) => theme.color.lightGrey};
  border-radius: ${({ theme }) => theme.borderRadius.radius10};
`;

export const SpeakersWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4.5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    display: flex;
    flex-direction: column;
  }
`;

export const LogoImage = styled.img`
  height: 35px;
  object-fit: contain;
`;

export const ToggableContent = styled.div<{ $isVisible: boolean }>`
  background-color: ${({ theme }) => theme.color.lightGrey2};
  overflow: hidden;
  max-height: ${({ $isVisible }) => ($isVisible ? '2000px' : '0')};
  transition: max-height 0.8s ease;
  border-bottom-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
`;

export const ToggleWrapper = styled.div`
  position: relative;
  height: 0;
  top: -19px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const ToggleButton = styled.button<{ themeColor?: string }>`
  border: none;
  background: white;
  border: 2px solid ${({ theme }) => theme.color.lightStrokeGrey};
  border-radius: 50%;
  padding: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 4rem;

  transition: background-color 0.2s ease;

  &:hover {
    border-color: ${({ theme, themeColor }) =>
      themeColor || theme.color.lightGrey};
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    flex-direction: column;
  }
`;
